import CaseOwnerProfileModal from "@/components/config_components/CaseOwnerProfileModal/CaseOwnerProfileModal.vue";
import { clear_auth_session } from "@/utils/auth/session_manager";

const COMPANY_ADMIN_SIDEBAR_GROUPS = [
  {
    id: 'workspace',
    label: 'Case Load',
    items: [
      { id: 'land-court-overview', label: 'Overview', icon: 'bi-speedometer2', route_name: 'LandCourtOverview' },
      { id: 'land-court-home', label: 'All cases', icon: 'bi-grid-3x3-gap', route_name: 'LandCourtHome' },
      { id: 'user-management', label: 'All Users', icon: 'bi-people', route_name: 'UserManagement' }
    ]
  }
];

const normalize_role = (role) => String(role || '').trim().toLowerCase();

const is_case_owner_role = (role) => {
  const normalized_role = normalize_role(role);

  return (
    normalized_role.includes('case owner')
    || normalized_role.includes('case_owner')
    || normalized_role === 'owner'
    || normalized_role.endsWith(' owner')
  );
};

const build_case_owner_profile = (current_lead_name) => ({
  initials: current_lead_name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase() || 'SN',
  name: current_lead_name || ''
});

export default {
  name: 'ConfigGlobalSidebar',
  components: {
    CaseOwnerProfileModal
  },
  data: () => ({
    show_case_owner_profile_modal: false
  }),
  async created() {
    await this.hydrate_land_court_case_count();
  },
  computed: {
    sidebar_groups() {
      return COMPANY_ADMIN_SIDEBAR_GROUPS.map((group) => ({
        ...group,
        items: group.items.map((item) => ({
          ...item,
          count: item.route_name === 'LandCourtHome' ? this.land_court_case_count : item.count,
        })),
      }));
    },
    current_role() {
      return this.$store.getters.currentRole || '';
    },
    current_lead_name() {
      return this.$store.getters.currentLeadName || '';
    },
    land_court_case_count() {
      const count = this.$store.getters.landCourtCaseCount;
      return Number.isFinite(Number(count)) ? Number(count) : 0;
    },
    sidebar_identity_title() {
      return 'Chambers';
    },
    sidebar_identity_subtitle() {
      return this.current_lead_name || 'Judge Lax - LCC';
    },
    uses_case_owner_sidebar() {
      return is_case_owner_role(this.current_role);
    },
    case_owner_profile() {
      return build_case_owner_profile(this.current_lead_name);
    },
    case_owner_work_items() {
      return [];
    },
    case_owner_status_items() {
      return [];
    },
    sidebar_primary_action_label() {
      return 'Load case';
    },
    sidebar_primary_action_route() {
      const next_query = { ...(this.$route?.query || {}) };
      delete next_query.entityTypeId;
      delete next_query.entity_type_id;

      return {
        name: 'LandCourtHome',
        query: {
          ...next_query,
          open_modal: 'load-case'
        }
      };
    }
  },
  methods: {
    async hydrate_land_court_case_count() {
      if (this.$store.getters.landCourtCaseCount !== null) {
        return;
      }

      this.$store.dispatch('setLandCourtCaseCount', 0);
    },
    sign_out() {
      clear_auth_session();
      this.$store.dispatch('resetStore');
      this.$router.push({ name: 'UserLogin' });
    },
    close_sidebar() {
      if (window.innerWidth >= 992) {
        return;
      }

      this.$emit('close');
    },
    open_case_owner_profile_modal() {
      this.show_case_owner_profile_modal = true;
    },
    go_to_sidebar_primary_action() {
      this.$router.push(this.sidebar_primary_action_route);
      this.close_sidebar();
    },
    close_case_owner_profile_modal() {
      this.show_case_owner_profile_modal = false;
    },
    handle_case_owner_profile_edit() {
      this.show_case_owner_profile_modal = false;
      this.$router.push({ name: 'LandCourtHome' });
      this.close_sidebar();
    },
    is_active_route(route_name) {
      return this.$route.name === route_name;
    }
  }
};
